export default __webpack_public_path__ + "static/media/White_Horse.b11cfd1b.png";